import Loadable from '../../components/loadable';

const DrawerPlaceholder = Loadable({
  loader: () => import('../../components/drawer_placeholder'),
  type: 'drawer',
});

angular.module('shared').value('DrawerPlaceholder', DrawerPlaceholder);
